// Nome do produto, usado como sufixo e como título de reserva
const APP_NAME = 'Trivenix'

/**
 * Define o título da aba do navegador.
 *
 * Com oito abas do sistema abertas — situação comum de quem passa o dia aqui — todas
 * exibiam "Triveni" e só dava para achar a certa clicando uma a uma. O nome da tela vem
 * primeiro porque a aba trunca o fim do texto quando há muitas abertas.
 *
 * @param {string|null|undefined} titulo Nome da tela. Vazio deixa só o nome do produto.
 */
export function setPageTitle(titulo) {
  const limpo = normalizar(titulo)

  document.title = limpo ? `${limpo} | ${APP_NAME}` : APP_NAME
}

/**
 * Alguns títulos vêm de dados do próprio registro e podem trazer marcação ou espaços
 * repetidos; o título da aba precisa ser texto simples de uma linha só.
 */
function normalizar(titulo) {
  if (typeof titulo !== 'string') {
    return ''
  }

  return titulo
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
